const chartsStyle = {
	dateRangeFilterWrapper: {
		display: 'flex',
		minWidth: '240px',
		paddingTop: '10px',
		marginBottom: '17px',
	},
	datePickerLabel: {
		fontSize: '11px',
		lineHeight: '21px',
		color: '#aaa',
	},
	datetimeWrapper: {
		marginRight: '10px',
		position: 'relative',
		'& .rdtPicker': {
			top: '100%',
			bottom: 'auto',
			right: '0',
			cursor: 'pointer',

			'&:after': {
				display: 'none',
			},
			'&:before': {
				display: 'none',
			},
		},

		'& input.form-control': {
			fontSize: '14px',
			cursor: 'pointer',
			fontFamily: 'Roboto',
			'&::placeholder': {
				color: '#ADAAAA',
				opacity: 1,
				fontSize: '14px',
				fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
				fontWeight: 400,
				lineHeight: 1.42857,
			},
		},
	},
	datetimeIcon: {
		padding: "0px",
		position: 'absolute',
		right: '0',
		bottom: '50%',
		transform: 'translateY(50%)',
		color: '#555',
	},
	clearIcon: {
		marginTop: '7px',
		color: '#8B8B8B ',
		cursor: 'pointer',
	}
};

export default chartsStyle;
